<script lang="ts">
    import type { Snippet } from 'svelte';

    interface Props {
        value: string | number;
        valueSnippet?: Snippet;
        label: Snippet;
        subtitle?: string;
        color: 'amber' | 'cyan' | 'violet' | 'emerald' | 'gray' | 'rose';
        nablaClass?: string;
        compact?: boolean;
        icon: Snippet;
    }

    let {
        value,
        valueSnippet,
        label,
        subtitle,
        color,
        nablaClass = '',
        compact = false,
        icon,
    }: Props = $props();

    const colorClasses: Record<string, { text: string; muted: string }> = {
        amber: { text: 'text-amber-400', muted: 'text-amber-400/60' },
        cyan: { text: 'text-cyan-400', muted: 'text-cyan-400/60' },
        violet: { text: 'text-violet-400', muted: 'text-violet-400/60' },
        emerald: { text: 'text-emerald-400', muted: 'text-emerald-400/60' },
        gray: { text: 'text-gray-400', muted: 'text-gray-400/60' },
        rose: { text: 'text-rose-400', muted: 'text-rose-400/60' },
    };

    const cls = $derived(colorClasses[color]);
</script>

<div class="bg-gray-900 rounded-lg shadow-sm border border-gray-700 {compact ? 'p-3' : 'p-5'} text-center">
    <div class="flex items-center justify-center {compact ? 'gap-1.5' : 'gap-2 sm:gap-3'}">
        <div class="{compact ? 'size-4' : 'size-6 sm:size-8 lg:size-10'} shrink-0 {cls.muted}">
            {@render icon()}
        </div>
        <p class="{compact ? 'text-3xl sm:text-4xl' : 'text-5xl sm:text-7xl lg:text-8xl'} font-nabla tabular-nums {nablaClass}">
            {#if valueSnippet}
                {@render valueSnippet()}
            {:else}
                {value}
            {/if}
        </p>
    </div>
    <p class="font-quantico {compact ? 'text-xs' : 'text-lg'} font-bold {cls.text} mt-2 uppercase tracking-wide">
        {@render label()}
    </p>
    {#if subtitle}
        <!-- eslint-disable-next-line svelte/no-at-html-tags -->
        <p class="font-quantico text-sm {cls.muted} mt-1.5 tabular-nums uppercase">{@html subtitle}</p>
    {/if}
</div>
